function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.877 25.793C21.0527 25.793 25.3398 21.5059 25.3398 16.3301C25.3398 11.1543 21.043 6.86719 15.8672 6.86719C10.6914 6.86719 6.4043 11.1543 6.4043 16.3301C6.4043 21.5059 10.7012 25.793 15.877 25.793ZM20.7891 16.3203C20.7891 16.5547 20.6914 16.7305 20.4961 16.9258L17.2734 20.1387C17.127 20.2852 16.9512 20.3535 16.7363 20.3535C16.3262 20.3535 16.0137 20.041 16.0137 19.6211C16.0137 19.4062 16.1016 19.2207 16.248 19.084L17.4199 17.9414L18.5527 17.0039L16.541 17.0918H11.6973C11.248 17.0918 10.9355 16.7695 10.9355 16.3203C10.9355 15.8711 11.248 15.5488 11.6973 15.5488H16.541L18.543 15.6367L17.4199 14.709L16.248 13.5566C16.1113 13.4199 16.0137 13.2246 16.0137 13.0195C16.0137 12.5996 16.3262 12.2871 16.7363 12.2871C16.9512 12.2871 17.127 12.3555 17.2734 12.4922L20.4961 15.7246C20.7012 15.9199 20.7891 16.0957 20.7891 16.3203Z",
  fill: "#EC7963"
});

function SvgArrowCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow_circle.e52e6cae.svg";
export { ForwardRef as ReactComponent };